import React from "react";
import IntroVideo from "@/components/IntroVideo";

export default function Stage1Video({ testid }) {
  return (
    <IntroVideo
      testid={testid}
      title="Stage 1: Meet Your P&L (free)"
      subtitle="Watch Penny & Ollie knock out Steps 2-4, then do them yourself below."
      embedUrl="https://dubb.com/v/LuRDm4/embed?width=auto&height=auto&autoplay=0&no_cta=1&no_controls=0&muted=0"
      paddingBottom="56.10%"
    />
  );
}
